var t=function(r){try{return!!r()}catch{return!0}};export{t as default};
